import { createContext, useContext } from 'react'

import { Filter } from '@cubejs-client/core'

export type CubeReportPageFiltersType = {
  pageFilters: Filter[]
  onChangePageFilters: (filters: Filter[]) => void
}

const CubeReportPageFiltersContext = createContext<CubeReportPageFiltersType>({
  pageFilters: [],
  onChangePageFilters: () => null,
})

export const useCubeReportPageFiltersContext = () =>
  useContext(CubeReportPageFiltersContext)

export default CubeReportPageFiltersContext
